module.exports = __webpack_public_path__ + "img/arrow-next-blue.a94ba1dd.svg";